$bog_gamengine_demo $mol_book2_catalog
	param \demo
	placeholders /$mol_view
	plugins /
		<= Control $mol_keyboard_state
			key <= key_map *
	spreads *
		quad <= Quad $mol_page
			title \Квад
			tools /
				<= Cam_switch $mol_switch
					value? <=> cam_kind? \flat
					options *
						flat \Плоская
						deep \Объёмная
				<= Pause $mol_check_box
					title \Пауза
					checked? <=> paused?
			body /
				<= Draw $bog_gamengine_draw
					scene <= Scene
					cam <= cam $bog_gamengine_cam
					stat => stat
			foot /
				<= Stat $mol_view
					sub / <= stat
		flat <= Flat $bog_gamengine_demo_flat
		room <= Room $bog_gamengine_demo_room
		boxes <= Boxes $bog_gamengine_demo_boxes
		jumper <= Jumper $bog_gamengine_demo_jumper
		shooter <= Shooter $bog_gamengine_demo_shooter
		legion <= Legion $bog_gamengine_demo_legion
		studio <= Studio $bog_gamengine_studio
		crumb <= Crumb $bog_gamengine_demo_crumb
		crumb_studio <= Crumb_studio $bog_gamengine_demo_crumb_studio
		crumb2 <= Crumb2 $bog_gamengine_demo_crumb2
	Clock $bog_gamengine_clock
		paused? => paused?
	Scene $bog_gamengine_scene
		clock <= Clock
		kids / <= Spin
		batches /
			<= Batch $bog_gamengine_batch
				nodes / <= Spin
	Spin $bog_gamengine_demo_spin
	Cam_flat $bog_gamengine_cam_flat
	Cam_deep $bog_gamengine_cam_deep
		pos <= cam_deep_pos Float32Array
